import React, { useEffect } from 'react';
import cn from 'classnames';
import { bool, string, func } from 'prop-types';
/**
 * Backdrop component.
 */

var Backdrop = function Backdrop(_ref) {
  var active = _ref.active,
      className = _ref.className,
      _onClick = _ref.onClick;
  useEffect(function () {
    var overlayClass = 'has-overlay';

    var addOverlay = function addOverlay() {
      return document.body.classList.add(overlayClass);
    };

    var removeOverlay = function removeOverlay() {
      return document.body.classList.remove(overlayClass);
    }; // The overlay prevents the body from scrolling when the modal is open


    if (active) {
      addOverlay();
    } else {
      removeOverlay();
    }

    return function () {
      removeOverlay();
    };
  }, [active]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(className, 'backdrop', active && 'backdrop--active'),
    role: "presentation",
    onClick: function onClick() {
      return _onClick();
    }
  });
};

Backdrop.defaultProps = {
  active: false,
  className: null,
  onClick: null
};
Backdrop.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Show the backdrop. */
  active: bool,

  /** Additional class names to add to the component root. */
  className: string,

  /** OnClick event */
  onClick: func
} : {};
export default Backdrop;